<template>
  <div id="wrapper" :class="{ wrap: !$route.meta.isPopup}">
    <a v-if="isConnectedAtm" class="end-button" @click="atmWsJobEnd">ATM 작업종료</a>
    <vue-headful :title="title" />
    <topMenu v-if="$route.meta.authRequired" />
    <keep-alive :include="cachedComponentList">
      <router-view :key="$route.fullPath"/>
    </keep-alive>
    <!-- <footerView v-if="$route.meta.authRequired" /> -->
    <a href="#" class="top"><i class="xi-angle-up-min"></i></a>
    <div id="loading" class="loading_wrap">
      <div class="circle"></div>
    </div>
    <FullModal
      ref="fullModal"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import TopMenu from '@/components/TopMenu'
import SideMenu from '@/components/SideMenu'
import FooterView from '@/components/FooterView'
import { EventBus } from '@/modules/event-bus'
import localedata from './locale/bos-locale'
import bosdictko from './locale/bos-dict-ko'
import bosdicten from './locale/bos-dict-en'
import { locale, loadMessages } from 'devextreme/localization'
import isEmpty from 'lodash/isEmpty'

import FullModal from '@/components/FullModal'

export default {
  name: 'App',
  components: {
    TopMenu,
    FooterView,
    SideMenu,
    FullModal
  },
  data: function () {
    return {
      title: 'mintit',
      isReaction: false,
      loginCheckTimer: null
    }
  },
  computed: {
    cachedComponentList () {
      return window.$store.getters['LatestMenu/getCachedComponentList']
    },
    getStoreAtmId () {
      return window.$store.getters['AtmWsStore/getReqAtmId']
    },
    getStoreNormalAtmId () {
      return window.$store.getters['AtmWsStore/getReqNormalAtmId']
    },
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResAtmInfo']
    },
    getStoreNormalAtmInfo () {
      return window.$store.getters['AtmWsStore/getResNormalAtmInfo']
    },
    getStoreFullModalList () {
      return window.$store.getters['ModalStore/getModalObjs']
    },
    getUserId () {
      return window.$store.getters['Login/getUserId']
    },
    getRoutePath () {
      return this.$route.path
    },
    isConnectedAtm () {
      return !isEmpty(this.getStoreAtmInfo)
    }
  },
  updated () {
    this.$nextTick(function () {
      var $gridArea = $('.grid_area > div:last-child'),
        $tabArea = ($('.sub_content').find('.tab_menu_list').hasClass('tab_menu_list')),
        $shArea = ($('.sub_content').find('.search_area').hasClass('search_area')),
        $auiArea = ($('.aui-grid').parent('div'))
      if ($tabArea === true) {
        $gridArea.removeClass('h500')
        $auiArea.removeClass('h500')
      } else if ($tabArea === false) {
        $gridArea.addClass('h500')
        $auiArea.addClass('h500')
      }
      if ($shArea === true) {
        $gridArea.removeClass('h600')
      } else if ($shArea === false) {
        $gridArea.addClass('h600')
      }
      if ($tabArea === false && $shArea === false) {
        $gridArea.removeClass('h500')
      }
    })
  },
  mounted () {
    // title 처리
    setInterval(() => this.title = 'mintit - ' + this.$router.history.current.meta.desc, 1000)

    $(window).scroll(function () {
      var $top = $(this).scrollTop()
      if ($top > 10) {
        $('.top').addClass('on')
      } else {
        $('.top').removeClass('on')
      }
    })

    $('.top').on('click', function () {
      $('html,body').animate({scrollTop: 0}, 500)
      return false
    })
  },
  created () {
    this.initMessages()
    locale(localedata.getLocale())
    // 사용자 action
    EventBus.$on('event-reaction', () => {
      this.isReaction = true

      if (this.loginCheckTimer == null) {
        const millisecondValue = 7200000 // 2시간  2000
        this.loginCheckTimer = setInterval(this.refreshLogin, millisecondValue)
      }
    })

    window.onbeforeunload = (event) => {
      if (event.clientX < 0) {
        event.returnValue = '경고: 페이지를 새로 고칩니다!'
      }
    }

    // 로그아웃
    EventBus.$on('event-logout', () => {
      this.isReaction = false

      clearInterval(this.loginCheckTimer)

      this.loginCheckTimer = null
    })
  },
  watch: {
    getStoreAtmId (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        window.$store.commit('AtmWsStore/setReqAtmId', newVal)
        window.$store.dispatch('AtmWsStore/getAtmInfo')
      }
      if (!newVal) {
        if (!isEmpty(this.getStoreAtmInfo)) {
          window.$store.dispatch('AtmWsStore/jobEndNoticeToAtm')
        }
        if (this.getRoutePath !== '/home' && this.getUserId) {
          this.$router.push('/home')
          setTimeout(() => {
            location.reload(true)
          }, 100)
        }
      }
    },
    getStoreNormalAtmId (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        window.$store.commit('AtmWsStore/setReqNormalAtmId', newVal)
        window.$store.dispatch('AtmWsStore/getDlvdInfo')
      }
    },
    getStoreFullModalList (newVal, oldVal) {
      if (newVal && newVal.length === 1 && newVal.length !== oldVal.length) {
        this.$modal.show('fullModal')
      } else if (newVal.length < 1) {
        this.$modal.hide('fullModal')
      }
    }
  },
  methods: {
    initMessages () {
      loadMessages(bosdictko.getDictionary())
      loadMessages(bosdicten.getDictionary())
    },
    refreshLogin () {
      const { meta: { authRequired } } = this.$route
      if (!authRequired) return
      if (this.isReaction) {
        window.$store.dispatch('Login/refreshLogin')
          .then((result) => {
            this.isReaction = false
            if (!result) {
              this.logout()
            }
          })
      } else {
        this.logout()
      }
    },
    logout () {
      window.$store
        .dispatch('Login/logout')
        .then(() => {
          this.$router.push('/')
        })
    },
    atmWsJobEnd () {
      if (!this.isConnectedAtm) {
        return
      }
      const { atm_name } = this.getStoreAtmInfo
      this.$Alert.confirm(`<Strong>${atm_name}</Strong>에 연결되어 있습니다.<br />ATM이 잘 잠겼는지 확인해주세요.<br /> '확인'을 터치하면 연결이 종료됩니다.`)
        .then(res => {
          if (res) {
            window.$store.dispatch('AtmWsStore/jobEndNoticeToAtm')
          }
        })
    }
  }
}
</script>

<style scoped>
  /* Windows 98-style button styles */
  .end-button {
    background-color: tomato;
    border: 1px solid #000;
    padding: 4px 8px;
    color: #FFFFFF;
    text-decoration: none;
    cursor: pointer;
    font-family: Tahoma, Arial, sans-serif;
    font-size: 12px;
    border-radius: 4px;
    box-shadow: 5px 5px 6px rgb(0 0 0 / 50%);
    margin-left: 11px;
    height: 35px;
    line-height: 25px;
    font-weight: bolder;
    animation: blink 0.3s infinite alternate;
    position: absolute;
    z-index: 1000;
    top: 10px;
    right: 60px;
  }
  @keyframes blink {
        0% {
            background-color: tomato;
        }
        50% {
            background-color: blue; /* Add the blue color here */
        }
        100% {
            background-color: tomato;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue